/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/305-shuffle': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M12 11h-1.586l-2.5-2.5 2.5-2.5H12v2.5L15.5 5 12 1.5V4h-2a.997.997 0 00-.707.293L6.5 7.086 3.707 4.293A1 1 0 003 4H0v2h2.586l2.5 2.5-2.5 2.5H0v2h3c.265 0 .52-.105.707-.293L6.5 9.914l2.793 2.793A1 1 0 0010 13h2v2.5l3.5-3.5L12 8.5V11z"/>'
  }
})
